var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import HTMLReactParser from "html-react-parser";
import styled, { keyframes } from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentAnimationIndex } from "../../../../../Selector/UISelector";
import { actions as UiAction } from '../../../../../Slice/UISlice';
import { actions } from "../../../../../Slice/ChatbotV2Slice";
import { selectScenarioAnimationLoading } from "../../../../../Selector/ChatBotV2Selector";
var blink = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n"], ["\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n"])));
var Cursor = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  background-color: black;\n  margin-left: 2px;\n  animation: ", " 0.8s steps(1) infinite;\n"], ["\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  background-color: black;\n  margin-left: 2px;\n  animation: ", " 0.8s steps(1) infinite;\n"])), blink);
export var TypingAnimation = function (_a) {
    var htmlText = _a.htmlText, _b = _a.speed, speed = _b === void 0 ? 1 : _b, containerRef = _a.containerRef;
    var _c = useState(0), visibleChars = _c[0], setVisibleChars = _c[1];
    var parsedContent = HTMLReactParser(htmlText);
    var currentAnimationIndex = useSelector(selectCurrentAnimationIndex);
    var scenarioAnimationLoading = useSelector(selectScenarioAnimationLoading);
    var dispatch = useDispatch();
    var flatContent = React.Children.toArray(parsedContent).reduce(function (acc, node) {
        if (typeof node === "string") {
            return __spreadArray(__spreadArray([], acc, true), node.split(""), true);
        }
        ;
        return __spreadArray(__spreadArray([], acc, true), [node], false);
    }, []);
    useEffect(function () {
        if (visibleChars < flatContent.length) {
            var timeout_1 = setTimeout(function () { return setVisibleChars(function (prev) { return prev + 5; }); }, speed);
            return function () { return clearTimeout(timeout_1); };
        }
        else {
            dispatch(UiAction.typingAnimation(true));
            if (scenarioAnimationLoading) {
                dispatch(UiAction.setCurrentAnimationIndex(currentAnimationIndex + 1));
            }
            dispatch(actions.setChatAnimationLoadingId(0));
        }
    }, [visibleChars, flatContent === null || flatContent === void 0 ? void 0 : flatContent.length, speed]);
    useEffect(function () {
        if (containerRef.current) {
            var _a = containerRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight, scrollTop = _a.scrollTop;
            var isAtBottom = scrollHeight - scrollTop === clientHeight;
            if (isAtBottom) {
                containerRef.current.scrollTop = scrollHeight;
            }
        }
    }, [visibleChars]);
    return (_jsxs("span", { children: [flatContent.slice(0, visibleChars).map(function (node, index) { return (_jsx("span", { children: node }, index)); }), _jsx(Cursor, {})] }));
};
var AnimatedTextComponent = function (props) {
    var htmlText = props.htmlText, containerRef = props.containerRef;
    return (_jsx("div", __assign({ id: "demo" }, { children: _jsx(TypingAnimation, { htmlText: htmlText, speed: 5, containerRef: containerRef }) })));
};
export default AnimatedTextComponent;
var templateObject_1, templateObject_2;
